export const ORG_INVOICE_PROFILE_LIMITS = {
  BILLING_CONTACT_NAME: 120,
  BILLING_ADDRESS_LINE: 200,
  BILLING_CITY: 100,
  BILLING_STATE_OR_REGION: 100,
  BILLING_POSTAL_CODE: 20,
  BILLING_COUNTRY: 2,
  COMPANY_REGISTRATION_NUMBER: 64,
  VAT_NUMBER: 32,
  PURCHASE_ORDER_NUMBER: 64,
  BILLING_EMAIL: 254,
} as const

export const ACCOUNT_INVOICE_DETAILS_TEST_IDS = {
  SECTION: 'account-invoice-details-section',
  SAVE_BUTTON: 'account-invoice-details-save',
} as const

export const ORG_INVOICE_DETAILS_COPY = {
  SECTION_TITLE: 'Invoice details',
  INTRO:
    'For company receipts and wire invoices, add your legal billing profile here. Self-serve card checkout collects address and tax via Stripe; use this form for manual or enterprise billing.',
  READ_ONLY_NOTE:
    'Package and seat count come from your active plan — you do not need to enter them.',
  BILLING_CONTACT_NAME_LABEL: 'Contact person (billing)',
  BILLING_CONTACT_NAME_PLACEHOLDER: 'Accounts payable contact',
  BILLING_EMAIL_LABEL: 'Invoice delivery email',
  BILLING_EMAIL_PLACEHOLDER: 'ap@company.com (optional)',
  BILLING_ADDRESS_LINE1_LABEL: 'Billing address',
  BILLING_ADDRESS_LINE1_PLACEHOLDER: 'Street address',
  BILLING_ADDRESS_LINE2_PLACEHOLDER: 'Suite, floor (optional)',
  BILLING_CITY_LABEL: 'City',
  BILLING_STATE_LABEL: 'State / region',
  BILLING_POSTAL_LABEL: 'Postal code',
  BILLING_COUNTRY_LABEL: 'Country',
  BILLING_COUNTRY_PLACEHOLDER: 'US',
  COMPANY_REG_LABEL: 'Company registration / Tax ID',
  COMPANY_REG_PLACEHOLDER: 'National tax or company number',
  VAT_LABEL: 'VAT number (if applicable)',
  VAT_PLACEHOLDER: 'EU/UK VAT ID',
  PO_LABEL: 'Purchase order number (if applicable)',
  PO_PLACEHOLDER: 'PO-12345',
  DERIVED_COMPANY: 'Company',
  DERIVED_PACKAGE: 'Package',
  DERIVED_SEATS: 'Participants',
  SAVE_BUTTON: 'Save invoice details',
  SAVE_SUCCESS: 'Invoice details saved',
  SAVE_FAILURE: 'Could not save invoice details',
  VALIDATION_COUNTRY: 'Country must be a 2-letter code (e.g. US, GB)',
  VALIDATION_EMAIL: 'Invoice delivery email must be valid',
} as const
